import { TFunction } from 'i18next';
import { Question } from './TradeInInterface';
import VehicleInfo from '../../assets/images/trade-in/steps/vehicle-information.svg?react';
import VehicleOptions from '../../assets/images/trade-in/steps/vehicle-options.svg?react';
import VehicleCondition from '../../assets/images/trade-in/steps/vehicle-condition.svg?react';
import PersonalInfo from '../../assets/images/trade-in/steps/personal-information.svg?react';
import { QuestionFormData } from 'pages/leadGen/LeadGenInterface';

export const stepperConstant = {
  step1: 1,
  step2: 2,
  step3: 3,
  step4: 4,
};

export const tradeInConstant = 'vehicleSearch';

export const widget_type_embedded = 'embedded';
export const widget_type_popup = 'popup';

export const VEHICLE_CONDITIONS = (t: TFunction): Question[] => {
  return [
    {
      id: 2,
      label: t('stepperFormTradeIn.que2'),
      labelTxt: 'Does your vehicle have any existing exterior damage?',
      required: false,
      options: [
        { value: 'yes', label: t('leadGenConst.yes') },
        { value: 'no', label: t('leadGenConst.no') },
      ],
    },
    {
      id: 3,
      label: t('stepperFormTradeIn.que3'),
      labelTxt: 'Does your vehicle have any existing interior damage?',
      required: false,
      options: [
        { value: 'yes', label: t('leadGenConst.yes') },
        { value: 'no', label: t('leadGenConst.no') },
      ],
    },
    {
      id: 4,
      label: t('stepperFormTradeIn.que4'),
      labelTxt: 'Does your vehicle have any accidents or claims in its history?',
      required: false,
      options: [
        { value: 'yes', label: t('leadGenConst.yes') },
        { value: 'no', label: t('leadGenConst.no') },
      ],
    },
    {
      id: 5,
      label: t('stepperFormTradeIn.que5'),
      labelTxt: 'Has your vehicle ever been smoked in?',
      required: false,
      options: [
        { value: 'yes', label: t('leadGenConst.yes') },
        { value: 'no', label: t('leadGenConst.no') },
      ],
    },
    {
      id: 6,
      label: t('stepperFormTradeIn.que6'),
      labelTxt: 'When did you last replace your tires?',
      required: false,
      options: [
        { value: '2', label: t('stepperFormTradeIn.lessThan2Years') },
        { value: '3', label: t('stepperFormTradeIn.twoToThreeYearsAgo') },
        { value: '4', label: t('stepperFormTradeIn.moreThan4Years') },
      ],
    },
    {
      id: 7,
      label: t('stepperFormTradeIn.que7'),
      labelTxt: 'Any indication your brakes may be worn, unusual sounds or pulsation while braking?',
      required: false,
      options: [
        { value: 'yes', label: t('leadGenConst.yes') },
        { value: 'no', label: t('leadGenConst.no') },
      ],
    },
  ];
};

export const VEHICLE_CONDITIONS_PAGE_2_1 = (t: TFunction): Question[] => {
  return [
    {
      id: 8,
      label: t('stepperFormTradeIn.que8'),
      labelTxt: 'Are there any chips or cracks in the windshield?',
      required: false,
      options: [
        { value: 'yes', label: t('leadGenConst.yes') },
        { value: 'no', label: t('leadGenConst.no') },
      ],
    },
    {
      id: 9,
      label: t('stepperFormTradeIn.que9'),
      labelTxt: 'Does your vehicle have any mechanical issues or dashboard warning lights?',
      required: false,
      options: [
        { value: 'yes', label: t('leadGenConst.yes') },
        { value: 'no', label: t('leadGenConst.no') },
      ],
    },
    {
      id: 10,
      label: t('stepperFormTradeIn.que10'),
      labelTxt: 'How many key fobs do you have for your vehicle?',
      required: false,
      options: [
        { value: 'none', label: t('stepperFormTradeIn.none') },
        { value: 'key1Fob', label: t('stepperFormTradeIn.key1Fob') },
        { value: 'key2Fob', label: t('stepperFormTradeIn.key2Fob') },
      ],
    },
    {
      id: 11,
      label: t('stepperFormTradeIn.que11'),
      labelTxt: 'Does your vehicle have a rebuilt or salvage status?',
      required: false,
      options: [
        { value: 'yes', label: t('leadGenConst.yes') },
        { value: 'no', label: t('leadGenConst.no') },
      ],
    },
    {
      id: 12,
      label: t('stepperFormTradeIn.que12'),
      labelTxt: 'Do you own your vehicle outright or is it leased or financed?',
      required: false,
      options: [
        { value: 'owned', label: t('stepperFormTradeIn.owned') },
        { value: 'leased', label: t('stepperFormTradeIn.leased') },
        { value: 'financed', label: t('stepperFormTradeIn.financed') },
      ],
      conditionalQuestions: {
        leased: [
          {
            id: 13,
            label: t('stepperFormTradeIn.que13'),
            labelTxt: 'How much do you still owe on your vehicle?',
            required: false,
            type: 'input',
          },
          {
            id: 14,
            label: t('stepperFormTradeIn.que14'),
            labelTxt: 'How much do you pay every month?',
            required: false,
            type: 'input',
          },
          {
            id: 15,
            label: t('stepperFormTradeIn.que15'),
            labelTxt: 'Who is your vehicle leased with?',
            required: false,
            type: 'input',
          },
        ],
        financed: [
          {
            id: 16,
            label: t('stepperFormTradeIn.que13'),
            labelTxt: 'How much do you still owe on your vehicle?',
            required: false,
            type: 'input',
          },
          {
            id: 17,
            label: t('stepperFormTradeIn.que14'),
            labelTxt: 'How much do you pay every month?',
            required: false,
            type: 'input',
          },
          {
            id: 18,
            label: t('stepperFormTradeIn.que16'),
            labelTxt: 'Who is your vehicle financed with?',
            required: false,
            type: 'input',
          },
        ],
      },
    },
    {
      id: 19,
      label: t('stepperFormTradeIn.que17'),
      labelTxt:
        'Would you like to sell your car or trade it in? You can change your mind later. Selection will not influence the offer you receive.',
      required: false,
      options: [
        { value: 'sell', label: t('stepperFormTradeIn.sell') },
        { value: 'tradeIn', label: t('stepperFormTradeIn.tradeIn') },
        { value: 'unsure', label: t('stepperFormTradeIn.unsure') },
      ],
    },
  ];
};
export const VEHICLE_CONDITIONS_PAGE_2 = (t: TFunction): Question[] => {
  return [
    {
      id: 'custom-question-1',
      label: 'When did you last replace your tires?',
      labelTxt: 'When did you last replace your tires?',
      required: true,
      options: [
        { value: 'Less than 2 Years Ago', label: 'Less than 2 Years Ago' },
        { value: '2 to 4 Years Ago', label: '2 to 4 Years Ago' },
        { value: 'More than 4 Years Ago or Unsure', label: 'More than 4 Years Ago or Unsure' },
      ],
    },
    {
      id: 'custom-question-2',
      label: t('stepperFormTradeIn.que12'),
      labelTxt: 'Do you own your vehicle outright or is it leased or financed?',
      required: true,
      options: [
        { value: 'owned', label: t('stepperFormTradeIn.owned') },
        { value: 'leased', label: t('stepperFormTradeIn.leased') },
        { value: 'financed', label: t('stepperFormTradeIn.financed') },
      ],
      conditionalQuestions: {
        leased: [
          {
            id: 'custom-question-3',
            parentValue: 'leased',
            label: t('stepperFormTradeIn.que13'),
            labelTxt: 'How much do you still owe on your vehicle?',
            required: true,
            type: 'number',
          },
          {
            id: 'custom-question-4',
            parentValue: 'leased',
            label: t('stepperFormTradeIn.que14'),
            labelTxt: 'How much do you pay every month?',
            required: true,
            type: 'number',
          },
          {
            id: 'custom-question-5',
            parentValue: 'leased',
            label: t('stepperFormTradeIn.que15'),
            labelTxt: 'Who is your vehicle leased with?',
            required: true,
            type: 'input',
          },
        ],
        financed: [
          {
            id: 'custom-question-6',
            parentValue: 'financed',
            label: t('stepperFormTradeIn.que13'),
            labelTxt: 'How much do you still owe on your vehicle?',
            required: true,
            type: 'number',
          },
          {
            id: 'custom-question-7',
            parentValue: 'financed',
            label: t('stepperFormTradeIn.que14'),
            labelTxt: 'How much do you pay every month?',
            required: true,
            type: 'number',
          },
          {
            id: 'custom-question-8',
            parentValue: 'financed',
            label: t('stepperFormTradeIn.que16'),
            labelTxt: 'Who is your vehicle financed with?',
            required: true,
            type: 'input',
          },
        ],
      },
    },
    {
      id: 'custom-question-9',
      label:
        'Would you like to sell your car or trade it in? You can change your mind later. Your selection will not influence the offer you receive.',
      labelTxt:
        'Would you like to sell your car or trade it in? You can change your mind later. Your selection will not influence the offer you receive.',
      required: true,
      options: [
        { value: 'sell', label: 'Sell' },
        { value: 'tradeIn', label: 'Trade In' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
  ];
};

export const VEHICLE_OPTIONS = (t: TFunction): Question[] => {
  return [
    {
      id: 1,
      label: t('stepperFormTradeIn.que1'),
      labelTxt: 'Select any options your vehicle has',
      options: [
        { value: 'Black Optics', label: 'Black Optics' },
        { value: 'Audi Sport', label: 'Audi Sport' },
        { value: 'Bronze Edition', label: 'Bronze Edition' },
        { value: 'Ceramic Brakes', label: 'Ceramic Brakes' },
        { value: 'w/o / PremiumPkg', label: 'w/o / PremiumPkg' },
      ],
    },
  ];
};

export const HEADER_STEPS_V3 = (t: TFunction) => {
  return [
    { step: 0, stepAllowed: [1, 2, 3, 4, 5, 6], Icon: VehicleInfo, name: t('stepperFormTradeIn.vehicleInformation') },
    { step: 1, stepAllowed: [2, 3, 4, 5, 6], Icon: VehicleOptions, name: t('stepperFormTradeIn.vehicleOptions') },
    { step: 2, stepAllowed: [3, 4, 5, 6], Icon: VehicleCondition, name: t('stepperFormTradeIn.vehicleCondition') },
    { step: 3, stepAllowed: [5, 6], Icon: PersonalInfo, name: t('stepperFormTradeIn.personalInformation') },
  ];
};

export const HEADER_STEPS_V4 = (t: TFunction) => {
  return [
    {
      step: 0,
      stepAllowed: [2, 3, 4, 5, 6, 7],
      Icon: VehicleInfo,
      name: t('stepperFormTradeIn.vehicleInformation'),
    },
    { step: 1, stepAllowed: [3, 4, 5, 6, 7], Icon: VehicleOptions, name: t('stepperFormTradeIn.vehicleOptions') },
    { step: 2, stepAllowed: [4, 5, 6, 7], Icon: VehicleCondition, name: t('stepperFormTradeIn.vehicleCondition') },
    { step: 3, stepAllowed: [5, 6, 7], Icon: PersonalInfo, name: t('stepperFormTradeIn.personalInformation') },
  ];
};

export const getHeaderSteps_ = (version: string, t: TFunction) => {
  switch (version) {
    case 'v3':
      return HEADER_STEPS_V3(t);
    case 'v4':
    default:
      return HEADER_STEPS_V4(t);
  }
};

export const getHeaderSteps = (type: string, version: string, t: TFunction): React.ReactElement | null => {
  const stepHeaderByTypeAndVersion: {
    [type: string]: { [version: string]: React.ReactElement | null };
  } = {
    banner: {
      '1.1': HEADER_STEPS_V3(t),
    },
    button: {
      '1.1': HEADER_STEPS_V4(t),
    },
    embed: {
      '1.0': HEADER_STEPS_V3(t),
      '1.1': HEADER_STEPS_V4(t),
    },
  };

  // Return based on type and version, or null if not found
  return stepHeaderByTypeAndVersion[type]?.[version] || null;
};

export const transformMultiChoiceData = (data: any, values: any, t: TFunction) => {
  return data?.map((question) => ({
    questionId: question.id,
    question: question.label,
    answer: question?.options
      ?.filter((option) => values[`${question.id}_${option.value}`])
      ?.map((option) => option.label),
    actualAnswerTxt: question.options
      ?.filter((option) => values[`${question.id}_${option.value}`])
      ?.map((option) => option.label)
      ?.join(', '),
  }));
};

// export const transformSingleChoiceData = (data: any, t: TFunction) => {
//   const dynamicQuestions: Record<string, string> = Object.keys(data)
//     .filter((key) => key.startsWith('questionIds-'))
//     .reduce((result: Record<string, string>, key) => {
//       result[key] = data[key];
//       return result;
//     }, {});

//   const updatedValues: QuestionFormData[] = [];
//   for (const [key, value] of Object.entries(dynamicQuestions)) {
//     updatedValues.push({
//       questionId: +key.slice(key.indexOf('-') + 1),
//       answer: [value],
//       question: [...VEHICLE_CONDITIONS_PAGE_2(t), ...VEHICLE_CONDITIONS(t)].find(
//         (question) => question.id === +key.slice(key.indexOf('-') + 1)
//       )?.labelTxt,
//     });
//   }
//   return updatedValues;
// };

// Utility to flatten questions
const flattenQuestions = (questions: Question[]): Question[] => {
  let flatQuestions: Question[] = [];

  const flatten = (questionArray: Question[]) => {
    for (const question of questionArray) {
      flatQuestions.push(question);
      if (question.conditionalQuestions) {
        Object.values(question.conditionalQuestions).forEach((conditionalArray) => {
          flatten(conditionalArray);
        });
      }
    }
  };

  flatten(questions);
  return flatQuestions;
};

// Updated transform function
export const transformSingleChoiceData = (questions: any, data: any, t: TFunction) => {
  const dynamicQuestions: Record<string, string> = Object.keys(data)
    .filter((key) => key.startsWith('questionIds-') && !key.includes('custom-question'))
    .reduce((result: Record<string, string>, key) => {
      result[key] = data[key];
      return result;
    }, {});

  // Flatten the questions
  // const allQuestions = flattenQuestions([...VEHICLE_CONDITIONS_PAGE_2(t), ...VEHICLE_CONDITIONS(t)]);
  const allQuestions = flattenQuestions([...questions]);

  const updatedValues: QuestionFormData[] = [];

  for (const [key, value] of Object.entries(dynamicQuestions)) {
    const questionId = +key.slice(key.indexOf('-') + 1);
    const question = allQuestions.find((q) => q.id === questionId);

    const actualAns = question?.options?.find((option) => option.value === value)?.label;

    // updatedValues.push({
    //   questionId,
    //   answer: [value],
    //   question: question?.labelTxt,
    // });

    updatedValues.push({
      questionId,
      answerText: value === 'NO' ? 'N' : value,
      actualAnswer: value,
      actualAnswerTxt: actualAns,
      question: question?.label,
    });
  }

  return updatedValues;
};

export const transformSingleChoiceCustomData_ = (questions: any, data: any) => {
  const dynamicQuestions: Record<string, string> = Object.keys(data)
    .filter((key) => key.includes('custom-question'))
    .reduce((result: Record<string, string>, key) => {
      result[key] = data[key];

      return result;
    }, {});

  // Flatten the questions
  // const allQuestions = flattenQuestions([...VEHICLE_CONDITIONS_PAGE_2(t), ...VEHICLE_CONDITIONS(t)]);
  const allQuestions = flattenQuestions([...questions]);

  const updatedValues: QuestionFormData[] = [];

  for (const [key, value] of Object.entries(dynamicQuestions)) {
    const questionId = +key.slice(key.lastIndexOf('-') + 1);

    const question = allQuestions.find((q) => Number(q.id?.slice(q.id?.lastIndexOf('-') + 1)) === questionId);

    updatedValues.push({
      questionId,
      answerText: value,
      actualAnswerTxt: value,
      question: question?.labelTxt,
      parentValue: question?.parentValue,
    });
  }

  return updatedValues;
};

export const transformSingleChoiceCustomData = (questions: any, data: any) => {
  const dynamicQuestions: Record<string, string> = Object.keys(data)
    .filter((key) => key.includes('custom-question'))
    .reduce((result: Record<string, string>, key) => {
      result[key] = data[key];
      return result;
    }, {});

  // Flatten the questions
  const allQuestions = flattenQuestions([...questions]);

  const updatedValues: QuestionFormData[] = [];

  for (const [key, value] of Object.entries(dynamicQuestions)) {
    const questionId = +key.slice(key.lastIndexOf('-') + 1);

    const question = allQuestions.find((q) => Number(q.id?.slice(q.id?.lastIndexOf('-') + 1)) === questionId);

    updatedValues.push({
      questionId,
      answerText: value,
      actualAnswerTxt: value,
      question: question?.labelTxt,
      parentValue: question?.parentValue,
    });
  }

  // Filter updatedValues dynamically
  const filteredValues = updatedValues.filter(
    (item) =>
      !item.parentValue || // Keep items without parentValue
      updatedValues.some((q) => q.answerText === item.parentValue) || // Keep items where parentValue matches any answerText
      !updatedValues.some((q) => q.parentValue) // Include questions with no dependency
  );

  return filteredValues;
};

export const GET_TRADE_IN_TYPE_ID = (version: string) => {
  switch (version) {
    case '1.0' || '1.1':
      return import.meta.env.VITE_TRADE_IN_TYPE_ID_V1_V2;
    case '1.2' || '1.3':
      return import.meta.env.VITE_TRADE_IN_TYPE_ID_V3_V4;
    default:
      return import.meta.env.VITE_TRADE_IN_TYPE_ID_V1_V2;
  }
};

export const GET_CREDIT_SCORE_TYPE_ID = (version: string) => {
  switch (version) {
    case 'v1' || 'v2' || 'v3':
      return import.meta.env.VITE_CREDIT_SCORE_TYPE_ID;
    default:
      return import.meta.env.VITE_CREDIT_SCORE_TYPE_ID;
  }
};

export const MODULE_NAME = 'tradeIn';

export const INPUT_TYPE = {
  1: 'radio',
  C: 'checkbox',
  D: 'date',
  T: 'input',
  L: 'select',
  $: 'number',
};

export const BLACK_BOOK_QUESTIONS = () => {
  return [
    {
      questionid: 1001000,
      parentid: 0,
      questionText: 'Does your vehicle use key fobs? If so, how many do you have?',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 1001000,
          answerText: '0',
          answerCode: '0',
          showChildren: false,
        },
        {
          questionid: 1001000,
          answerText: '1',
          answerCode: '1',
          showChildren: false,
        },
        {
          questionid: 1001000,
          answerText: '2+',
          answerCode: '2',
          showChildren: false,
        },
        {
          questionid: 1001000,
          answerText: 'NA',
          answerCode: 'N',
          showChildren: false,
        },
      ],
    },

    {
      questionid: 4001000,
      parentid: 0,
      questionText: 'Are there any instrument warning lights on? (Check Engine, Service Soon, etc.)',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 4001000,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
        },
        {
          questionid: 4001000,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
        },
      ],
    },
    {
      questionid: 4001000,
      parentid: 0,
      questionText: 'Are there any instrument warning lights on? (Check Engine, Service Soon, etc.)',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 4001000,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
        },
        {
          questionid: 4001000,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
        },
      ],
    },
    {
      questionid: 4003004,
      parentid: 0,
      questionText: 'Does your vehicle have an fluid leak that you cannot identify?',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 4003004,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
        },
        {
          questionid: 4003004,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
        },
      ],
    },

    {
      questionid: 5001001,
      parentid: 0,
      questionText: 'Are there dents, dings or hail damage on the vehicle? Rate the damage.',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 5001001,
          answerText: 'Minor',
          answerCode: '1',
          showChildren: false,
        },
        {
          questionid: 5001001,
          answerText: 'Moderate',
          answerCode: '2',
          showChildren: false,
        },
        {
          questionid: 5001001,
          answerText: 'Extensive',
          answerCode: '3',
          showChildren: false,
        },
        {
          questionid: 5001001,
          answerText: 'None',
          answerCode: 'N',
          showChildren: false,
        },
      ],
    },
    {
      questionid: 5005001,
      parentid: 0,
      questionText: 'Are any of the wheels scraped, scuffed, or bent? How many?',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 5005001,
          answerText: '0',
          answerCode: '0',
          showChildren: false,
        },
        {
          questionid: 5005001,
          answerText: '1',
          answerCode: '1',
          showChildren: false,
        },
        {
          questionid: 5005001,
          answerText: '2',
          answerCode: '2',
          showChildren: false,
        },
        {
          questionid: 5005001,
          answerText: '3',
          answerCode: '3',
          showChildren: false,
        },
        {
          questionid: 5005001,
          answerText: '4',
          answerCode: '4',
          showChildren: false,
        },
      ],
    },
    {
      questionid: 6001001,
      parentid: 0,
      questionText: 'Are there any burns, stains, or tears in the seats?  Rate the damage.',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 6001001,
          answerText: 'Minor',
          answerCode: '1',
          showChildren: false,
        },
        {
          questionid: 6001001,
          answerText: 'Moderate',
          answerCode: '2',
          showChildren: false,
        },
        {
          questionid: 6001001,
          answerText: 'Extensive',
          answerCode: '3',
          showChildren: false,
        },
        {
          questionid: 6001001,
          answerText: 'None',
          answerCode: 'N',
          showChildren: false,
        },
      ],
    },
    {
      questionid: 7004003,
      parentid: 0,
      questionText: 'Does a CARFAX or AutoCheck report indicate that your vehicle has an odometer discrepancy?',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 7004003,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
        },
        {
          questionid: 7004003,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
        },
      ],
    },

    {
      questionid: 7004004,
      parentid: 0,
      questionText: 'Does a CARFAX or AutoCheck report indicate that your vehicle has been stolen and recovered?',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 7004004,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
        },
        {
          questionid: 7004004,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
        },
      ],
    },

    {
      questionid: 7004001,
      parentid: 0,
      questionText: 'Does a CARFAX or AutoCheck report indicate that your vehicle has been in an accident?',
      helpText: '',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 7004001,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
        },
        {
          questionid: 7004001,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
        },
      ],
    },
    {
      questionid: 7003000,
      parentid: 0,
      questionText: 'Is the title listed in your name and in your possession with no liens?',
      helpText:
        'A certificate of title (sometimes referred to as car title, pink slip, pinks) legally establishes an owner to the vehicle. The vehicle has a lien on the title if the lienholder (party with financial interest) has not received payment in full for the vehicle.',
      inputType: '1',
      required: false,
      answers: [
        {
          questionid: 7003000,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
        },
        {
          questionid: 7003000,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
        },
      ],
    },
  ];
};

export const BLACK_BOOK_QUESTIONS_V2 = () => {
  return [
    {
      questionid: 9001000,
      parentid: 0,
      questionText: 'Has the vehicle ever had frame damage?',
      helpText: '',
      inputType: '1',
      required: true,
      answers: [
        {
          questionid: 9001000,
          answerText: 'No',
          answerCode: 'NO',
          showChildren: false,
          keyTxt: 'No frame damage',
        },
        {
          questionid: 9001000,
          answerText: 'Yes',
          answerCode: 'N',
          showChildren: false,
          keyTxt: 'Has frame damage',
        },
      ],
    },

    {
      questionid: 5001002,
      parentid: 0,
      questionText: 'Are there any scratches, chips or dull paint on the vehicle? Rate the damage.',
      helpText: '',
      inputType: '1',
      required: true,
      answers: [
        {
          questionid: 5001002,
          answerText: 'Minor',
          answerCode: '1',
          showChildren: false,
        },
        {
          questionid: 5001002,
          answerText: 'Moderate',
          answerCode: '2',
          showChildren: false,
        },
        {
          questionid: 5001002,
          answerText: 'Extensive',
          answerCode: '3',
          showChildren: false,
        },
        {
          questionid: 5001002,
          answerText: 'None',
          answerCode: 'N',
          showChildren: false,
        },
      ],
    },

    {
      questionid: 7004001,
      parentid: 0,
      questionText: 'Does your vehicle have any accidents or claims in its history?',
      helpText: '',
      inputType: '1',
      required: true,
      answers: [
        {
          questionid: 7004001,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
          keyTxt: 'No accidents',
        },
        {
          questionid: 7004001,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
          keyTxt: 'Has accident history',
        },
      ],
    },

    {
      questionid: 6002000,
      parentid: 0,
      questionText: 'Has your vehicle ever been smoked in?',
      helpText: 'Examples: smoke, mold, mildew, rotten food, food spill',
      inputType: '1',
      required: true,
      answers: [
        {
          questionid: 6002000,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
          keyTxt: 'Never smoked in',
        },
        {
          questionid: 6002000,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
          keyTxt: 'Smoked in',
        },
      ],
    },

    {
      questionid: 5003000,
      parentid: 0,
      questionText: 'Are there any chips or cracks in the windshield?',
      helpText: '',
      inputType: '1',
      required: true,
      answers: [
        {
          questionid: 5003000,
          answerText: 'No',
          answerCode: 'N',
          showChildren: false,
          keyTxt: 'No chips or cracks in windshield',
        },
        {
          questionid: 5003000,
          answerText: 'Yes',
          answerCode: 'Y',
          showChildren: false,
          keyTxt: 'Has chips or cracks in windshield',
        },
      ],
    },

    {
      questionid: 1001000,
      parentid: 0,
      questionText: 'Does your vehicle use key fobs? If so, how many do you have?',
      helpText: '',
      inputType: '1',
      required: true,
      answers: [
        {
          questionid: 1001000,
          answerText: '0',
          answerCode: '0',
          showChildren: false,
          keyTxt: 'No key fobs',
        },
        {
          questionid: 1001000,
          answerText: '1',
          answerCode: '1',
          showChildren: false,
          keyTxt: 'Has less than 2 keys',
        },
        {
          questionid: 1001000,
          answerText: '2+',
          answerCode: '2',
          showChildren: false,
          keyTxt: 'Has 2 or more keys',
        },
      ],
    },

    {
      questionid: 4001000,
      parentid: 0,
      questionText: 'Does your vehicle have any mechanical issues or dashboard warning lights?',
      helpText: '',
      inputType: '1',
      required: true,
      answers: [
        {
          questionid: 4001000,
          answerText: 'No',
          answerCode: 'NO',
          showChildren: false,
          keyTxt: 'No mechanical issues',
        },
        {
          questionid: 4001000,
          answerText: 'Yes',
          answerCode: 'N',
          showChildren: false,
          keyTxt: 'Has mechanical issues',
        },
      ],
    },

    {
      questionid: 7004005,
      parentid: 0,
      questionText: 'Does your vehicle have a rebuilt or salvage status?',
      helpText: '',
      inputType: '1',
      required: true,
      answers: [
        {
          questionid: 7004005,
          answerText: 'No',
          answerCode: 'NO',
          showChildren: false,
          keyTxt: 'No rebuilt or salvage status',
        },
        {
          questionid: 7004005,
          answerText: 'Yes',
          answerCode: 'N',
          showChildren: false,
          keyTxt: 'Has rebuilt or salvage title',
        },
      ],
    },
  ];
};

export const colorStyles = {
  containerClass: 'tradein-v3__body__ext-color',
  listClass: 'tradein-v3__body__ext-color__list',
  itemClass: 'tradein-v3__body__ext-color__item',
  labelClass: 'tradein-v3__body__ext-color__color',
  paletteClass: 'tradein-v3__body__ext-color__palette',
  nameClass: 'tradein-v3__body__ext-color__name',
};
